<template>
    <div class="history-order">
        <div class="container">
            <a href="javascript:void(0);" class="go-back" @click="$router.go(-1)">
              Повернутися
            </a>
            <div :class="['history-order__wrapp',{'disabled':documentDisabled}]">
                <div class="history-order__item">
                    <div class="history-order__head">
                        Страховий продукт
                    </div>
                    <div class="history-order__form-group">
                        <div class="row">
                            <div class="col-md-4">
                                <label>Компанія</label>
                                <input type="text" class="form-control" v-model="order.companyInfo.name" disabled>
                            </div>
                            <div class="col-md-4">
                                <label>Ліміт покриття</label>
                                <input type="text" class="form-control" v-model="order.offer.coverage" disabled>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="history-order__item">
                    <div class="history-order__head">
                        Розрахунок
                    </div>
                    <div class="history-order__form-group">
                        <div class="history-order__form-heading">Дата дії договору:</div>
                        <div class="row">
                            <div class="col-md-4">
                                <label>Початок</label>
                                <input  v-if="skeletonOff" disabled v-model="order.contract.startedAt" class="form-control date-selector">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Закінчення</label>
                                <input v-if="skeletonOff"  disabled v-model="order.contract.finishedAt" class="form-control date-selector">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Розрахунковий період</label>
                                <input v-if="skeletonOff" type="text" class="form-control" v-model="orderPeriod" disabled>
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="history-order__item history-order__client">
                    <div class="history-order__head">
                        Дані страхувальника
                    </div>
                    <div class="history-order__form-group">
                        <div class="history-order__form-heading">Ідентифікація:</div>
                        <div class="row">
                            <div v-if="! isLegalType()" class="col-md-4">
                                <label>Повне ім'я</label>
                                <input v-if="skeletonOff" type="text" placeholder="" class="form-control" v-model="order.insurant.fullName" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div v-if="! isLegalType()" class="col-md-4">
                                <label>Дата народження</label>
                                <input v-if="skeletonOff" v-model="order.insurant.dateBirthAt" class="form-control date-selector" placeholder="" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>{{isLegalType() ? 'ЄДРПОУ' : 'ІПН' }}</label>
                                <input v-if="skeletonOff" type="text" class="form-control" v-model="order.insurant.documentation.uin" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <label>{{ isDocumentIdCard() ? 'Запис документу' : 'Серія закордонного паспорту' }}</label>
                                <input v-if="skeletonOff" type="text" placeholder="Запись №" class="form-control" v-model="order.insurant.documentation.serial" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div v-if="!this.isDocumentERetiree(order.insurant.privilegeTypeId)" class="col-md-4">
                                <label>Номер документу</label>
                                <input v-if="skeletonOff" type="text" placeholder="Документ №" class="form-control" v-model="order.insurant.documentation.number" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>{{ !this.isDocumentERetiree(order.insurant.privilegeTypeId) ? 'Дата выдачі' : 'Закінчення дії' }}</label>
                                <input v-if="skeletonOff" v-model="order.insurant.documentation.dateOfIssue" class="form-control date-selector" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                    </div>
                    <div class="history-order__form-group">
                        <div class="history-order__form-heading">Контактна інформація:</div>
                        <div class="row">
                            <div class="col-md-4">
                                <label>Телефон</label>
                                <input v-if="skeletonOff" type="text" placeholder="Телефон" class="form-control" v-model="order.insurant.phone" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Email</label>
                                <input v-if="skeletonOff" type="text" placeholder="Email" class="form-control" v-model="order.insurant.email" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                            <div class="col-md-4">
                                <label>Адреса</label>
                                <input v-if="skeletonOff" type="text" placeholder="Адреса" class="form-control" v-model="order.insurant.address" :disabled="documentDisabled">
                                <PuSkeleton v-else class="skeleton-input"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="history-order__item">
                    <div class="history-order__head">
                        Дані учасників
                    </div>
                    <div class="history-order">
                        <div class="history-order__form-heading">Ідентифікація:</div>
                        <div class="history-order__form-group" v-for="item in order.insurants" :key="item.id" :item="item">
                            <div class="row">
                                <div class="col-md-4">
                                    <label>Повне ім'я</label>
                                    <input v-if="skeletonOff" type="text" placeholder="Повне ім'я" class="form-control" v-model="item.fullName" disabled>
                                    <PuSkeleton v-else class="skeleton-input"/>
                                </div>
                                <div class="col-md-4">
                                    <label>Дата народження</label>
                                    <input v-if="skeletonOff" type="text" placeholder="Дата народження" class="form-control" v-model="item.dateBirthAt" disabled>
                                    <PuSkeleton v-else class="skeleton-input"/>
                                </div>
                                <div class="col-md-4">
                                    <label>{{isLegalType() ? 'ЄДРПОУ' : 'ІПН' }}</label>
                                    <input v-if="skeletonOff" type="text" class="form-control" v-model="item.documentation.uin" :disabled="documentDisabled">
                                    <PuSkeleton v-else class="skeleton-input"/>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <label>{{ isDocumentIdCard(item) ? 'Запис документу' : 'Серія закордонного паспорту' }}</label>
                                    <input v-if="skeletonOff" type="text" placeholder="Серія закордонного паспорту" class="form-control" v-model="item.documentation.serial" :disabled="documentDisabled">
                                    <PuSkeleton v-else class="skeleton-input"/>
                                </div>
                                <div class="col-md-4">
                                    <label>Номер документу</label>
                                    <input v-if="skeletonOff" type="text" placeholder="Номер закордонного паспорту" class="form-control" v-model="item.documentation.number" :disabled="documentDisabled">
                                    <PuSkeleton v-else class="skeleton-input"/>
                                </div>
                                <div class="col-md-4">
                                    <label>Дата выдачі</label>
                                    <input v-if="skeletonOff" v-model="item.documentation.dateOfIssue" class="form-control date-selector" :disabled="documentDisabled">
                                    <PuSkeleton v-else class="skeleton-input"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="history-order__price">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="history-order__price__item">
                                <p>Платіж:</p>
                                <b> {{ showPrice() }} <span>грн</span></b>
                            </div>
                            <div v-if="showDiscountPrice()" class="history-order__price__item">
                                <p>З урахуванням знижки:</p>
                                <b> {{ showDiscountPrice() }} <span>грн</span></b>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="history-order__nav">
                    <div class="row">

                    </div>
                </div>

                <div v-if="this.loadData" class="partner-order__nav">
                    <div class="row">
                        <div class="col-md-8" v-if="order.edit">
                            <div class="row">
                                <div v-if="order.statusId == 1 && user && user.recipientTypeId !== 4" class="col-md-6">
                                    <button type="button" @click="declare()" class="btn-blue-w">Редагувати і заявити</button>
                                </div>
                                <div v-if="order.statusId == 5 && user && user.recipientTypeId !== 4" class="col-md-6">
                                    <button type="button" @click="conclude()" class="btn-blue-w">Оформити</button>
                                </div>
                                <div class="col-md-6">
                                    <button type="button" @click="draft()" class="btn btn-dark">Переглянути чернетку</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4" v-if="!hideCopyForApi">
                            <button :disabled="isCopyProcess" type="button" @click="copy()" class="btn btn-success">
                                <span v-if="isCopyProcess" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                <span v-else>Копіювати</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Multiselect from 'vue-multiselect';
const FileDownload = require('js-file-download');
import { showOrder, concludeOrder } from '../../api/order';
import { customerMixin, HistoryMixin } from "../../mixin";
import {list as calculateTourism} from "@/api/tourismInsuranceCompany";

export default {
    components: {Multiselect},
    mixins: [customerMixin, HistoryMixin],
    data: function () {
        return {
            loadData: false,
            skeletonOff: false,
            isCopyProcess: false,
            togglerVisible: true,
            documentDisabled: true,
            orderPeriod: 'Мультивіза',
            humans: [],
            birthDates: [],
            order: {
                offer: {},
                contract: {},
                companyInfo: {},
                insuranceObject: {},
                insurant:{
                    documentation: {},
                }
            }
        };
    },

     async created() {
        this.order = await showOrder(this.$route.params.orderId).then((response) => {
            return response.data.data;
        });

         this.loadData = true;
         this.skeletonOff = true;

         this.getContractPeriod();
     },
    computed : {
      user() {
        return this.$store.getters.USER;
      },
    },
    mounted () {
        this.getContractPeriod();
    },

    methods: {
      //TODO duplicate with historyMixin need refactoring
        async copy() {
            this.isCopyProcess = true;
            const startDate = moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()+1)).format('DD.MM.YYYY');

            let offer = {};
            // this.humans = [
            //     {name: 'Діти до 1 року ', value: 0, min: 0, max: 1, birthDates: [], id:1},
            //     {name: 'Діти до 3 років ', value: 0, min: 2, max: 3,  birthDates: [], id:2},
            //     {name: 'Підлітки до 18 років ', value: 0, min: 4, max: 18,  birthDates: [], id:3},
            //     {name: 'Дорослі до 69 років ', value: 0, min: 19, max: 69, birthDates: [], id:4},
            //     {name: 'Дорослі 70-75 років ', value: 0, min: 70, max: 75, birthDates: [], id:5},
            //     {name: 'Літні 76-100 років ', value: 0, min: 76, max: 100, birthDates: [], id:6}
            // ]
            this.birthDates = [];

            this.order.insurants.forEach(item => {
              this.birthDates.push(item.dateBirthAt)
            })
            // this.fillHumans(this.order.insurants);

            // const calculateDate =  this.calculateDate(startDate, this.order.offer.period_option, this.order.offer.yearProgram);

            const paramsTourism = {
                date: startDate,
                // end: calculateDate.endDate,
                days: this.order.offer.period_option,
                country: {id:this.order.offer.country.id,ewa_id:this.order.offer.country.ewa_id,name:this.order.offer.country.name},
                tourists: this.order.offer.tourists,
                // humans: this.humans,
                // yearProgram: this.order.offer.yearProgram,
                multiVisa: this.order.offer.yearProgram,
                birthDates: this.birthDates,
                // filters: {
                //     "franchise": "",
                //     "options_list": [],
                //     "activities": {
                //         "name": "Без активності",
                //         "value": "no_activities"
                //     },
                //     "activitiesItem": "Без активностей"
                // },
                // activities: "no_activities",
                moduleId: this.order.moduleId
            };


            let responseTourism = await calculateTourism(paramsTourism);

            offer = this.$_.find(responseTourism?.data?.data, (item) => {
              return item.company.id === this.order.companyInfo.companyId
                && item.tripProgram === this.order.offer.trip_program
                && item.tourists === this.order.offer.tourists
                && parseInt(item.coverage) === parseInt(this.order.offer.coverage)
                && parseInt(item.franchise) === parseInt(this.order.offer.franchise)
                && item.id === this.order.offer.external_id;
            });
            // offer = this.$_.find(responseTourism?.data?.data, (item) => {
            //     return item.company.id == this.order.companyInfo.companyId && item.tripProgram == this.order.offer.trip_program && item.tourists == this.order.offer.tourists && parseInt(item.coverage) == parseInt(this.order.offer.coverage) && item.franchise == this.order.offer.franchise;
            // });

            let userInfo = {
                "identificationCode":this.order.insurant.documentation.uin,
                "withoutIdentificationCode":this.order.insurant.documentation.withoutUin,
                "name":this.order.insurant.name,
                "surname":this.order.insurant.surname,
                "dateBirth":this.order.insurant.dateBirthAt,
                "phone":this.order.insurant.phone,
                "mail":this.order.insurant.email,
                "city":this.order.insurant.cityObject,
                "street":this.order.insurant.street,
                "house":this.order.insurant.house,
                "apartment":this.order.insurant.apartment,

                // new
                "documentation": {
                    type: this.order.insurant.documentation.documentType,
                    serial: this.order.insurant.documentation.serial,
                    number: this.order.insurant.documentation.number,
                    issuedBy: this.order.insurant.documentation.issuedBy,
                    dateOfIssue: this.order.insurant.documentation.dateOfIssue,
                    endDateOfIssue: this.order.insurant.documentation.endDateOfIssue,
                },
                "documentType":this.order.insurant.documentation.documentType,
                "passportSerial":this.order.insurant.documentation.serial,
                "passportNumber":this.order.insurant.documentation.number,
                "passportDate":this.order.insurant.documentation.dateOfIssue
            };
            let TouristsList = [];

            this.order.insurants.forEach((insurant) => {
                TouristsList.push({ name: insurant.name, surname: insurant.surname, dateBirth: insurant.dateBirthAt, identificationCode: insurant.documentation.uin,
                  withoutIdentificationCode: insurant.documentation.withoutUin,
                    passportSerial: insurant.documentation.serial, passportNumber: insurant.documentation.number, passportDate: insurant.documentation.dateOfIssue});
            })

            if (!offer?.offerId) {
                this.$store.commit('CLEAR_TOURISM_FULL_ORDER');
                this.$store.commit('CLEAR_TOURISM_INFO_TOURISTSLIST');
                this.$store.commit('CLEAR_SEARCH_TOURISM_PARAMS');
                this.$store.commit('CLEAR_TOURISM_INFO_OFFER');
                this.$store.commit('CLEAR_TOURISM_INFO_USER');
                this.$store.commit('SET_SEARCH_TOURISM_PARAMS', paramsTourism);
                this.$store.commit('SET_TOURISM_INFO_USER', userInfo);
                this.$store.commit('SET_TOURISM_INFO_TOURISTSLIST', TouristsList);

                this.$router.push({name: `tourismResult`});

                return;
            }

            this.order.price = offer.price;
            this.order.offer.id = offer.offerId;
            this.order.offer.available_documents = offer.available_documents ?? null;

            const endDateInfo = this.calculateDate(startDate, this.order.offer.period_option, this.order.offer.yearProgram);
            this.order.contract.startedAt = startDate;
            this.order.contract.finishedAt = endDateInfo.endDate;

            this.declare(true);
        },
        draft() {
            window.open(`/api/orders/draft/${this.$store.getters.USER.id}/${this.$route.params.orderId}`);
        },
        conclude() {
            concludeOrder(this.order.id)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.$alert("ОСЦПВ вдало оформлено!", '',);
                        this.$router.push({name: "history"});

                        return true;
                    }

                    this.$alert("ОСЦПВ не оформлено!", '', 'error');
                }).catch((error) => {
                    this.$alert("ОСЦПВ не оформлено", '', 'error');
                });
        },
        showPrice() {
            let price = parseFloat(this.order.price) + parseFloat((this.order?.dgo?.price || 0));

            if (isNaN(price)) {
                return 0;
            }

            return price.toFixed(2);
        },
        fillHumans: function(insurants){
            insurants.forEach((insurant) => {
                const birthDate = moment(insurant.dateBirthAt, 'DD.MM.YYYY')
                const age = moment().diff(birthDate, 'years');
                if (age < 1) {
                    this.humans[0].value++;
                    this.humans[0].birthDates.push(insurant.dateBirthAt);
                    this.birthDates.push(insurant.dateBirthAt);
                } else if (age < 3) {
                    this.humans[1].value++;
                    this.humans[1].birthDates.push(insurant.dateBirthAt);
                    this.birthDates.push(insurant.dateBirthAt);
                } else if (age < 18) {
                    this.humans[2].value++;
                    this.humans[2].birthDates.push(insurant.dateBirthAt);
                    this.birthDates.push(insurant.dateBirthAt);
                } else if (age < 70) {
                    this.humans[3].value++;
                    this.humans[3].birthDates.push(insurant.dateBirthAt);
                    this.birthDates.push(insurant.dateBirthAt);
                } else if (age < 76) {
                    this.humans[4].value++;
                    this.humans[4].birthDates.push(insurant.dateBirthAt);
                    this.birthDates.push(insurant.dateBirthAt);
                } else if (age < 80) {
                    this.humans[5].value++;
                    this.humans[5].birthDates.push(insurant.dateBirthAt);
                    this.birthDates.push(insurant.dateBirthAt);
                }
            })
        },
        calculateDate(startDate, period_option, yearProgram) {
            // Преобразуем строку в объект moment
            let startMoment = moment(startDate, 'DD.MM.YYYY');

            // Получаем сегодняшнюю дату
            const today = moment().startOf('day');

            // Оформлення день у день дозволене: дату в минулому підтягуємо до сьогодні
            if (startMoment.isBefore(today)) {
                startMoment = today.clone();
            }

            // Установим endMoment на period_option дней после startMoment
            let endMoment = startMoment.clone().add(period_option, 'days');

            // Если установлен флаг yearProgram, увеличим endMoment на год
            if (yearProgram) {
                endMoment = startMoment.clone().add(1, 'year').subtract(1, 'day');
            }

            // Возвращаем новые даты в формате 'дд.мм.гггг'
            return {
                startDate: startMoment.format('DD.MM.YYYY'),
                endDate: endMoment.format('DD.MM.YYYY')
            };
        },
        showDiscountPrice() {
            if (this.order.discountPrice) {
                let price = parseFloat(this.order.discountPrice);

                if (isNaN(price)) {
                    return 0;
                }

                if (price) {
                  return price.toFixed(2);
                }

                return 0;
            }

            return 0;
        },
        declare(isCopy = false) {
            let discountData = this.calcDiscountData(this.order);

            let offerInfo = {
                "id":this.order.offer.external_id,
                "company":this.order.companyInfo.info,
                "tripProgram":this.order.offer.trip_program,
                "title":this.order.companyInfo.name,
                "options":this.order.offer.options,
                "programs":this.order.offer.programs,
                "members":this.order.offer.members,
                "external_id":this.order.offer.external_id,
                "startDate":this.order.offer.startDate,
                "endDate":this.order.offer.endDate,
                "moduleId":this.order.moduleId,
                "period_option":this.order.offer.period_option,
                "risks":this.order.offer.risks,
                "ages":this.order.offer.ages,
                "price":this.order.offer.price,
                "limit":this.order.offer.coverage,
                "coverage":this.order.offer.coverage,
                "franchise":this.order.offer.franchise ?? 0,
                "offerId":this.order.offer.id,
                "purposeOfTrip":this.order.offer.purposeOfTrip,
                "fullPrice":this.order.allPrice,
                "available_documents": this.order.offer?.available_documents ?? null,
                "allowed_documents": this.order.offer?.allowed_documents ?? null,
                "discountPrice" : discountData ? discountData : 0,
                "dynamicDiscountPrice" : discountData ? discountData : 0,
            };

            if(discountData){
              offerInfo = { ...offerInfo, ...discountData };
            }

            offerInfo.company.id = this.order.companyInfo.companyId;

            this.birthDates = [];

            // this.humans = [
            //     {name: 'Діти до 1 року ', value: 0, min: 0, max: 1, birthDates: [], id:1},
            //     {name: 'Діти до 3 років ', value: 0, min: 2, max: 3,  birthDates: [], id:2},
            //     {name: 'Підлітки до 18 років ', value: 0, min: 4, max: 18,  birthDates: [], id:3},
            //     {name: 'Дорослі до 69 років ', value: 0, min: 19, max: 69, birthDates: [], id:4},
            //     {name: 'Дорослі 70-75 років ', value: 0, min: 70, max: 75, birthDates: [], id:5},
            //     {name: 'Літні 76-100 років ', value: 0, min: 76, max: 100, birthDates: [], id:6}
            // ];

          this.order.insurants.forEach(item => {
            this.birthDates.push(item.dateBirthAt)
          })
            // this.fillHumans(this.order.insurants);

            let searchInfo = {
                end: this.order.contract.finishedAt,
                date: this.order.contract.startedAt,
                days: this.order.offer.period_option,
                country: {id:this.order.offer.country.id,ewa_id:this.order.offer.country.ewa_id,name:this.order.offer.country.name},
                tourists: this.order.offer.tourists,
                // humans: this.humans,
                yearProgram: this.order.offer.yearProgram,
                multiVisa: this.order.offer.yearProgram,
                birthDates: this.birthDates,
                // filters: {
                //     "franchise": "",
                //     "options_list": [],
                //     "activities": {
                //         "name": "Без активності",
                //         "value": "no_activities"
                //     },
                //     "activitiesItem": "Без активностей"
                // },
                // activities: "no_activities",
            };

            let userInfo = {
                "identificationCode":this.order.insurant.documentation.uin,
                "withoutIdentificationCode":this.order.insurant.documentation.withoutUin,
                "name":this.order.insurant.name,
                "surname":this.order.insurant.surname,
                "dateBirth":this.order.insurant.dateBirthAt,
                "phone":this.order.insurant.phone,
                "mail":this.order.insurant.email,
                "city":this.order.insurant.cityObject,
                "street":this.order.insurant.street,
                "house":this.order.insurant.house,
                "apartment":this.order.insurant.apartment,

                // new

                "documentation": {
                    type: this.order.insurant.documentation.documentType,
                    serial: this.order.insurant.documentation.serial,
                    number: this.order.insurant.documentation.number,
                    issuedBy: this.order.insurant.documentation.issuedBy,
                    dateOfIssue: this.order.insurant.documentation.dateOfIssue,
                    endDateOfIssue: this.order.insurant.documentation.endDateOfIssue,
                },


                "documentType":this.order.insurant.documentation.documentType,
                "passportSerial":this.order.insurant.documentation.serial,
                "passportNumber":this.order.insurant.documentation.number,
                "passportDate":this.order.insurant.documentation.dateOfIssue
            };

            let TouristsListInfo = [];

            this.order.insurants.forEach((item, key) => {
                TouristsListInfo.push({
                    "name":item.name,
                    "surname":item.surname,
                    "dateBirth":item.dateBirthAt,
                    "identificationCode":item.documentation.uin,
                    "withoutIdentificationCode":item.documentation.withoutUin,
                    "passportSerial":item.documentation.serial,
                    "passportNumber":item.documentation.number,
                    "passportDate":item.documentation.dateOfIssue,
                    "passportIssuedBy":item.documentation.issuedBy,
                    "passportEndDate":item.documentation.endDateOfIssue,
                    "documentType": item.documentation.documentType,
                });
            });

            let params = {
                type: "next",
                statusId: 0
            };
            this.$store.commit('CLEAR_TOURISM_INFO_TOURISTSLIST');
            this.$store.commit('CLEAR_SEARCH_TOURISM_PARAMS');
            this.$store.commit('CLEAR_TOURISM_INFO_OFFER');
            this.$store.commit('CLEAR_TOURISM_INFO_USER');
            this.$store.commit('CLEAR_TOURISM_FULL_ORDER');
            this.$store.commit('SET_TOURISM_INFO_OFFER', offerInfo);
            this.$store.commit('SET_TOURISM_INFO_USER', userInfo);
            this.$store.commit('SET_TOURISM_INFO_TOURISTSLIST', TouristsListInfo);
            this.$store.commit('SET_SEARCH_TOURISM_PARAMS', searchInfo);
            this.orderId  = (isCopy) ? null : this.order.id;
            this.$store.commit('SET_TOURISM_FULL_ORDER', this.orderId);

            this.$router.push({name: 'tourismSteps', query: {from: 'history'}});
        },
        showTypeDocument() {
            if (this.order.insurant?.documentation?.type) {
                return this.$_.findWhere(this.$store.getters.DOCUMENTS_TYPES, { id: this.order.insurant.documentation.type })?.name;
            }
        },
        showAutoCategory() {
            if (this.order.insuranceObject.autoCategory) {
                return `(${this.order.insuranceObject.autoCategory})`;
            }
        },

        showCityRegister() {
            if (this.order.insurant.city) {
                return this.order.insurant.city;
            }
            /*if (this.order.insurant.city) {
                return this.order.offer.city.name_full_name_ru;
            }*/
        },
        getContractPeriod(){
            // if(!this.order.offer.yearProgram) {
                if(this.order.offer.period_option == 1){
                    this.orderPeriod = this.order.offer.period_option+' день'
                }else if(this.order.offer.period_option > 1 && this.order.offer.period_option < 5){
                    this.orderPeriod = this.order.offer.period_option+' дні'
                }else {
                    this.orderPeriod = this.order.offer.period_option+' днів'
                }
            // }
        },

        isDocumentIdCard(touristItem = null) {
          if (touristItem && touristItem.documentation) {
            return touristItem.documentation.documentType && touristItem.documentation.documentType === 3;
          } else {
            return this.order.insurant.documentation.documentType && this.order.insurant.documentation.documentType === 3;
          }
        },
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

